import React from 'react';
import { defineMessages, FormattedNumber, FormattedMessage } from 'react-intl';

import { NumberFormattingService } from 'ui-components/services/number-formatting-service';
import { DimensionUnit } from '../../enums/dimension-unit';
import { WeightUnit } from '../../enums/weight-unit';
import { UnitConversionService } from '../../services/unit-conversion-service';
import { UNIT_POUND, UNIT_OUNCE, UNIT_INCH, INTL_NUMBER_STYLE_UNIT, INTL_NUMBER_UNIT_DISPLAY_SHORT } from './intl-unit-formatting-service';
import { DimensionFormattedMessage } from './dimension-formatted-message';

// TODO: the ICU syntax here does not seem to follow locale decimal separators like FormattedNumber does
const messages = defineMessages({
  poundAndOunce: {
    description: 'pound and ounce unit number e.g. 1 lb 2 oz',
    defaultMessage: '{pound, number, ::measure-unit/pound} {ounce, number, ::measure-unit/ounce}',
    id: 'qHgY5r',
  },
});

class IntlImperialUnitFormattingServiceClass {
  formatWeight({ value, unit }) {
    const valueInPounds = UnitConversionService.convertValue(value, unit, WeightUnit.Pounds);
    if (Number.isNaN(valueInPounds) || valueInPounds === undefined || valueInPounds === null) {
      return '';
    }
    let integerPounds = Math.floor(valueInPounds);
    const valueInOunces = UnitConversionService.sumValues(
      [
        { value, unit },
        {
          value: -1 * integerPounds,
          unit: WeightUnit.Pounds,
        },
      ],
      WeightUnit.Ounces,
    );
    let roundedOunces = NumberFormattingService.roundToPlace(valueInOunces, 2, true);
    if (roundedOunces === '16') {
      integerPounds += 1;
      roundedOunces = '0';
    }
    if (integerPounds > 0 && roundedOunces !== '0') {
      return (
        <FormattedMessage
          {...messages.poundAndOunce}
          values={{
            pound: integerPounds,
            ounce: roundedOunces,
          }}
        />
      );
    }
    if (integerPounds > 0) {
      return (
        <FormattedNumber
          style={INTL_NUMBER_STYLE_UNIT}
          unit={UNIT_POUND}
          unitDisplay={INTL_NUMBER_UNIT_DISPLAY_SHORT}
          value={integerPounds}
        />
      );
    }
    if (roundedOunces !== '0') {
      return (
        <FormattedNumber
          style={INTL_NUMBER_STYLE_UNIT}
          unit={UNIT_OUNCE}
          unitDisplay={INTL_NUMBER_UNIT_DISPLAY_SHORT}
          value={roundedOunces}
        />
      );
    }
    if (integerPounds === 0 && roundedOunces === '0') {
      return <FormattedNumber style={INTL_NUMBER_STYLE_UNIT} unit={UNIT_OUNCE} unitDisplay={INTL_NUMBER_UNIT_DISPLAY_SHORT} value={0} />;
    }
  }

  formatDimensions({ length, width, height, unit }) {
    const round = (value) => Math.round((value + Number.EPSILON) * 100) / 100;
    const lengthInInches = round(length ? UnitConversionService.convertValue(length, unit, DimensionUnit.Inches) : 0);
    const widthInInches = round(width ? UnitConversionService.convertValue(width, unit, DimensionUnit.Inches) : 0);
    const heightInInches = round(height ? UnitConversionService.convertValue(height, unit, DimensionUnit.Inches) : 0);

    return <DimensionFormattedMessage height={heightInInches} length={lengthInInches} unit={UNIT_INCH} width={widthInInches} />;
  }
}

export const IntlImperialUnitFormattingService = new IntlImperialUnitFormattingServiceClass();
